import React from 'react';
import ReactNotification, { store } from 'react-notifications-component';

type TranslateFn = (id: string, defaultMessage: string) => string
let _t: TranslateFn = (_, defaultMessage) => defaultMessage
export const setNotifierTranslate = (fn: TranslateFn) => { _t = fn }

const standardOptions = {
  title: 'Info',
  message: '',
  type: 'info',
  insert: 'top',
  container: 'bottom-left',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: { duration: 3000 },
  dismissable: { click: true }
};

// Tracks title+message combinations currently on screen so a rapid repeat action
// (e.g. double-clicking a button before the previous toast auto-dismisses) doesn't
// stack identical toasts on top of each other.
const activeNotifications = new Set();

const _notify = (params, options={}) => {
  const notification = Object.assign({}, standardOptions, options, params)
  const dedupeKey = `${notification.type}:${notification.title}:${notification.message}`
  if (activeNotifications.has(dedupeKey)) return
  activeNotifications.add(dedupeKey)

  const onRemoval = notification.onRemoval
  notification.onRemoval = (...args) => {
    activeNotifications.delete(dedupeKey)
    if (onRemoval) onRemoval(...args)
  }

  store.addNotification(notification)
};

export const createNotification = {
  error:      (message, options={}) => _notify({ title: _t('toast.title.error',   'Error'),   type: 'danger',  message: '' + message }, options),
  errorKey:   (key: string, defaultMessage: string, options={}) => _notify({ title: _t('toast.title.error', 'Error'), type: 'danger', message: _t(key, defaultMessage) }, options),
  info:       (message, options={}) => _notify({ title: _t('toast.title.info',    'Info'),    type: 'info',    message: '' + message }, options),
  warning:    (message, options={}) => _notify({ title: _t('toast.title.warning', 'Warning'), type: 'warning', message: '' + message }, options),
  success:    (message, options={}) => _notify({ title: _t('toast.title.success', 'Success'), type: 'success', message: '' + message }, options),
};

export const Notifier = () => React.createElement(ReactNotification);
